import type { FC, ReactNode } from 'react';
import { Box, Container } from '@material-ui/core';

const Panel: FC<ReactNode> = ({ children }) => (
  <Box
    sx={{
      backgroundColor: 'background.default',
      minHeight: '100%',
      py: 8,
    }}
  >
    <Container style={{ maxWidth: '1920px' }}>{children}</Container>
  </Box>
);

export default Panel;
